import { DakokuDataFull, DakokuDetailData, DakokuInfoShinsei } from "@/types/Dakoku";
import { DateUtil } from "@/utils/DateUtil";
import { onMounted, reactive, ref, Ref } from "vue";

export function useDakokuDetailModal() {

  const dakokuDetailModalRef = ref();

  const detailData = ref<DakokuDetailData>({
    dakoku_id: 0,
    user_id: 0,
    koyou_keiyaku_id: 0,
    koyou_keiyaku_time_id: 0,
    mst_syuugyou_basyo_id: 0,
    dakoku_date: null,
    syukkin_datetime: null,
    syukkin_round_datetime: null,
    gaisyutsu_datetime: null,
    gaisyutsu_round_datetime: null,
    modori_datetime: null,
    modori_round_datetime: null,
    taikin_datetime: null,
    taikin_round_datetime: null,
    kyuukei_times: null,
    kyuukei_round_times: null,
    syotei_work_times: null,
    koujo_times: null,
    houteinai_zangyou_times: null,
    jikangai_work_times: null,
    shinya_warimashi_times: null,
    chikoku_times: null,
    soutai_times: null,
    is_yuukyuu: false,
    yuukyuu_tani_type: 0,
    is_kekkin: false,
    is_kibiki: false,
    kibiki_tani_type: 0,
    is_furide: false,
    is_furikyuu: false,
    furikyuu_tani_type: 0,
    is_kosyoku_teate: false,
    is_nittyoku_teate: false,
    is_kiken_teate: false,
    is_hannichi_hosei: false,
    syounin_status_type: 0, // 1:承認待ち 2:承認済 3:否認済
    syounin_status_notes: '', // 否認理由
    is_saishin: false,
    honnin_notes: null, // 本人コメント
    soumu_change_user_id: null,
    yuukyuu_times: null,
    // DakokuDetailData
    is_koukyuu: false,
    staff_name: '',
    syuugyou_basyo_name: null,
  });
  const shinseis: Ref<DakokuInfoShinsei> = ref({
    hayabanOsoban: [],
    koukyuu: [],
    jikangai: [],
    kyuukei: [],
    furikyuu: [],
    yuukyuu: [],
    kekkin: [],
    soutai: [],
    chikoku: [],
    nittyoku: [],
    kibiki: [],
    hannichiHosei: [],
    syuusei: [],
  })

  onMounted(async () => {

  });

  const setData = async (syuuseiTarget: DakokuDataFull | null, datetime: string) => {
    if (!syuuseiTarget) {
      syuuseiTarget = {} as DakokuDataFull
    }

    detailData.value = Object.assign(syuuseiTarget, {
      is_koukyuu: false,
      staff_name: '',
      syuugyou_basyo_name: null,
    });
  }

  const dakokuDetailModalParts = reactive({
    title: '詳細',
    button: ''
  })

  const openDakokuDetailModal = () => {
    dakokuDetailModalRef.value.open()
  }

  const closeDakokuDetailModal = () => {
    dakokuDetailModalRef.value.close()
  }

  const setShinseis = async(shinseiInfo: DakokuInfoShinsei | null) => {
    if(shinseiInfo){
      shinseis.value = shinseiInfo
    }
  }

  return {
    dakokuDetailModalRef,
    dakokuDetailModalParts,
    openDakokuDetailModal,
    closeDakokuDetailModal,
    detailData,
    setData,
    shinseis,
    setShinseis,
  }
}
